module.exports = __webpack_public_path__ + "static/cdph-4a2b2f35e8559a9c332cedea8ca82e30.png";